<mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
  <h3 class="mb-3 text-lg font-semibold text-slate-900">Risk screening</h3>
  <div class="grid gap-2 text-sm">
    <div class="flex items-center justify-between gap-3">
      <div class="flex items-center gap-2 text-slate-700">
        <mat-icon class="!text-base" [class.text-green-600]="store.riskScreeners().length > 0" [class.text-slate-400]="store.riskScreeners().length === 0">
          {{ store.riskScreeners().length > 0 ? 'check_circle' : 'radio_button_unchecked' }}
        </mat-icon>
        Suicide risk screener
        @if (store.riskScreeners().length === 0) {
          <span class="text-slate-500">- not yet captured</span>
        }
      </div>
      @if (canRecordScreener()) {
        <a mat-flat-button [routerLink]="['/interventions', interventionId(), 'risk-screeners', 'new']">
          {{ store.riskScreeners().length > 0 ? 'Record another' : 'Start screener' }}
        </a>
      }
    </div>
    @for (screener of store.riskScreeners(); track screener.id) {
      <div class="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 py-2 last:border-b-0">
        <div class="flex items-center gap-3">
          <span
            class="rounded-full px-2 py-0.5 text-xs font-medium"
            [class.bg-red-50]="screener.riskRatingCode === 'HIGH_RISK'"
            [class.text-red-700]="screener.riskRatingCode === 'HIGH_RISK'"
            [class.bg-amber-50]="screener.riskRatingCode === 'MEDIUM_RISK'"
            [class.text-amber-700]="screener.riskRatingCode === 'MEDIUM_RISK'"
            [class.bg-green-50]="screener.riskRatingCode === 'LOW_RISK'"
            [class.text-green-700]="screener.riskRatingCode === 'LOW_RISK'">
            {{ screener.riskRatingName }}
          </span>
          <span class="text-slate-700">{{ screener.screenedDate | date: 'yyyy-MM-dd' }}</span>
          <span class="text-slate-500">{{ screener.screenedByName }}</span>
        </div>
        <a mat-stroked-button [routerLink]="['/interventions', interventionId(), 'risk-screeners', screener.id]">View</a>
      </div>
    }
  </div>
</mat-card>
